import InfoDetails from './InfoDetails';
import { InfoDetailsProps, InfoDetailsValueProps } from './types';

export type { InfoDetailsProps, InfoDetailsValueProps };
export default InfoDetails;
